import { ReactElement, ReactNode } from 'react';
import Tippy from '@tippyjs/react';
import type { Plugin } from 'tippy.js';

interface DicaProps {
  conteudo: ReactNode;
  children: ReactElement;
}

/** Esc esconde a dica aberta (WCAG 1.4.13): o plugin do próprio Tippy, que não vem ligado por padrão. */
const esconderComEsc: Plugin = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn({ hide }) {
    function aoTeclar(evento: KeyboardEvent) {
      if (evento.key === 'Escape') hide();
    }

    return {
      onShow() {
        document.addEventListener('keydown', aoTeclar);
      },
      onHide() {
        document.removeEventListener('keydown', aoTeclar);
      },
    };
  },
};

/**
 * Dica de passar o mouse na nova identidade: fundo branco, texto escuro, cantos arredondados e
 * seta, sem título, como a moldura dos modais. As cores ficam no tema `jj-dica` do `App.scss`,
 * porque a regra global de `.tippy-box` pinta tudo de preto com `!important`.
 * Abre com o mouse e com o foco do teclado; Esc fecha.
 */
export default function Dica({ conteudo, children }: DicaProps) {
  return (
    <Tippy theme="jj-dica" content={conteudo} plugins={[esconderComEsc]}>
      {children}
    </Tippy>
  );
}
